import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { MyUtility } from '../../comparison';
import { Entity } from '../../criterias/select-list/select-list.component';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  constructor(public api: ApiService) { }

  public users = [];
  public clients: Entity[];

  ngOnInit() {
    console.log('oninit');
    this.getUsersAndClients();
  }

  getUsersAndClients() {
    console.log('getUsers');
    let call = this.api.getAllUsers();
    call.successFunc = x => {
      console.log("users", x);
      this.users = x;

      let clientRequest = this.api.getClients();
      clientRequest.successFunc = y => this.clients = y;
      clientRequest.start();
    };
    call.start();
  }

  deleteUser(user){
    if(!confirm("Are you sure you want to delete this user?"))
      return;

    let call = this.api.deleteUser(user.Id);
    call.successFunc =() => {
      console.log("deletion done. getting users");
      this.getUsersAndClients();

    }
    call.start();
  }

  showUserModal = false;
  editingUser : any = {};
  addMode = false;

  newUser(){
    this.addMode = true;
    this.editingUser = {LogoImageFilename:"SDLN",ApplicationName:"SDLN"};
    this.showUserModal = true;
  }

  editUser(user){
    this.addMode = false;
    this.editingUser = MyUtility.deepCopy(user);
    this.showUserModal = true;
  }

  saveUser(){
    let request = this.addMode? this.api.createUser(this.editingUser):this.api.updateUser(this.editingUser);
    request.successFunc = () => {
      this.getUsersAndClients();
      this.showUserModal = false;
    };
    request.start();
  }

  cancelUserModal(){
    this.showUserModal = false;
  }

  public get allViews(){
    return this.api.session.allViews;
  }
}
